const tabHeadingBlock = document.querySelector('.product_description_tab_heading_block');
const tabHeading = document.querySelectorAll('.product_description_tab_heading');
const tabContent = document.querySelectorAll('.product_description_tab_content_block');
const accHeading = document.querySelectorAll('.product_description_tab_faq_accordion_heading');
const accMobileHeading = document.querySelectorAll('.product_description_accordion_heading');

tabHeadingBlock.addEventListener('click', function(e) {
  const clicked = e.target.closest('.product_description_tab_heading');
  tabHeading.forEach( (th) => th.classList.remove('product_description_tab_heading--active') );
  clicked.classList.add('product_description_tab_heading--active');
  tabContent.forEach( (tc) => tc.classList.remove('product_description_tab_content_block--active') );
  document.querySelector(`.product_description_tab_content_block--${ clicked.dataset.tab }`).classList.add('product_description_tab_content_block--active');
  
});

accHeading.forEach( (ah) => {
  ah.addEventListener('click', () => {
    const content = ah.nextElementSibling;
    ah.classList.toggle('product_description_tab_content_block--active');
    content.style.display = content.style.display === 'block' ? 'none' : 'block';
  });
});

accMobileHeading.forEach( (amh) => {
  amh.addEventListener('click', () => {
    const content = amh.nextElementSibling;
    document.querySelectorAll('.product_description_accordion_content').forEach(item => {
      if (item !== content) {
        item.style.display = 'none';
      }
    });
    accMobileHeading.forEach( (amh) => amh.classList.remove('product_description_accordion_heading--active') );
    amh.classList.toggle('product_description_accordion_heading--active');
    content.style.display = content.style.display === 'block' ? 'none' : 'block';
  });
});
